
/**
 * params:
 *      logo: logo
 *      banner: 首页banner图
 *      bannerHref: 首页banner图的链接
 *      appid: appid
 *      areaCode: 地址
 *      isallarea: 是否显示首页地区选择功能
 *      isLogin: 是否匿名登录（true： 匿名登录）
 *      serviceType: 下载匹配报告的type值（定制）; serviceType: 'ls' =》表示下载的报告无logo
 *      isRapidLimitCity: 在匹配页面设置对应城市的地区选择
 *      isSwiper: 是否显示首页轮播图
 *
 * dg: 东莞推广
 * ssipc: 深圳科技工业园集团
 * xian: 西安
 * tazg: 天安智谷 -> 深圳
 * lgct: 龙岗城投 -> 深圳龙岗
 * tusocean: 湛江启迪海洋 -> 广东湛江
 * tlsp: 园小二（苏州吴中数字科技产业发展有限公司） -> 苏州
 * next: 新一代产业园 -> 福田区、深圳市、省级、国家部委
 * lgis: 龙岗产服 -> 龙岗区、深圳市、省级、国家部委
 * tqjg: 特区建工 -> 深圳
 *
 * */
let data = [
  {
    "name": "tgc",
    "appid": 'ccw',
    "serveid": 'E84B1298-369C-4193-A7CD-ADB17D31B63C',
    "logo": require('../images/logo.png'),
    "loginLogo": require('../images/login-logo.png'),
    "logoWidth": "80px",
    "loginLogoWidth": "100px",
    "banner": require('../images/banner.png'),
    "bannerHref": 'https://mp.weixin.qq.com/s/MS7XpvTYMRkhVbKNbrZ-7Q',
    "areaCode": 'RegisterArea_HNDQ_Guangdong_SZ',
    "areaName": '深圳',
    "isallarea": false,
    "serviceType": ""
  },
   /*  已停用 S */
  {
    "name": "tg",
    "appid": 'dg',
    "serveid": '95d72318-cd3c-4ae3-9c83-e11f5f6653f7',
    "logo": require('../images/logo.png'),
    "loginLogo": require('../images/login-logo.png'),
    "logoWidth": "80px",
    "loginLogoWidth": "100px",
    "banner": require('../images/banner.png'),
    "bannerHref": 'https://mp.weixin.qq.com/s/MS7XpvTYMRkhVbKNbrZ-7Q',
    "areaCode": 'RegisterArea_HNDQ_Guangdong_DongGuan',
    "areaName": '东莞',
    "isallarea": false,
    "serviceType": ""
  },
  {
    "name": "tgc",
    "appid": 'xian',
    "serveid": '685066ad-2846-4bea-ac39-e93b101126e3',
    "logo": require('../images/logo.png'),
    "loginLogo": require('../images/login-logo.png'),
    "logoWidth": "80px",
    "loginLogoWidth": "100px",
    "banner": require('../images/banner.png'),
    "bannerHref": 'https://mp.weixin.qq.com/s/MS7XpvTYMRkhVbKNbrZ-7Q',
    "areaCode": 'RegisterArea_XBDQ_Shanxi_XiAnShi',
    "areaName": '西安',
    "isallarea": false,
    "serviceType": ""
  },  
  {
    "name": "tgj",
    "appid": 'js',
    "serveid": '685066ad-2846-4bea-ac39-e93b101126e3',
    "logo": require('../images/configure/jingshi/login-logo.png'),
    "loginLogo": require('../images/configure/jingshi/login-logo.png'),
    "logoWidth": "260px",
    "loginLogoWidth": "326px",
    "banner": require('../images/banner.png'),
    "bannerHref": '#',
    "areaCode": 'RegisterArea_HNDQ_Guangdong_SZ',
    "areaName": '深圳',
    "isallarea": false,
    "serviceType": ""
  },  
  {
    "name": "tgs",
    "appid": 'ssipc',
    "serveid": '3d978fd7-f5f4-4663-8895-9b7075780390',
    "logo": require('../images/configure/ssipc/logo.png'),
    "loginLogo": require('../images/configure/ssipc/login_logo.png'),
    "logoWidth": "115px",
    "loginLogoWidth": "237px",
    "banner": require('../images/configure/ssipc/banner.jpg'),
    "bannerHref": '#',
    "areaCode": 'RegisterArea_HNDQ_Guangdong_SZ',
    "areaName": '深圳',
    "isallarea": true,
    "isLogin": true,
    "serviceType": ""
  },


// 以下停用日期：2024.12.25 
  
  {
    "name": "tgl",
    "appid": 'lgct',
    "serveid": '98cd69ba-e749-4e62-9390-6a29055ad6e6',
    "logo": require('../images/configure/lgct/logo.png'),
    "loginLogo": require('../images/configure/lgct/logo.png'),
    "logoWidth": "80px",
    "loginLogoWidth": "166px",
    "banner": require('../images/configure/lgct/banner.jpg'),
    "bannerHref": '#',
    "areaCode": 'RegisterArea_HNDQ_Guangdong_SZ_LG',
    "areaName": '龙岗',
    "isallarea": false,
    "isLogin": true,
    "serviceType": ""
  },
  {
    "name": "tgz",
    "appid": 'tusocean',
    "serveid": '3de168ae-e398-44aa-b876-46e8a73ce31e',
    "logo": require('../images/configure/tusocean/logo.png'),
    "loginLogo": require('../images/configure/tusocean/logo.png'),
    "logoWidth": "80px",
    "loginLogoWidth": "166px",
    "banner": require('../images/banner.png'),
    "bannerHref": '#',
    "areaCode": 'RegisterArea_HNDQ_Guangdong_ZhanJiang',
    "areaName": '湛江',
    "isallarea": true,
    "serviceType": ""
  },
  {
    "name": "tgy",
    "appid": 'tlsp',
    "serveid": '1c2cbf29-1e19-4bbe-9dbd-a03ec748d0f1',
    "logo": require('../images/configure/tlsp/logo.png'),
    "loginLogo": require('../images/configure/tlsp/logo.png'),
    "logoWidth": "80px",
    "loginLogoWidth": "166px",
    "banner":  require('../images/configure/tlsp/banner.jpg'),
    "bannerHref": '#',
    "areaCode": 'RegisterArea_HDDQ_Jiangsu_SuZhou',
    "areaName": '苏州',
    "isallarea": false,
    "isLogin": true,
    "serviceType": "tlsp",
    "isRapidLimitCity": true
  },

  // 2025.6.13 根据要求停用
  {
    "name": "tgn",
    "appid": 'next',
    "serveid": '',
    "logo": require('../images/configure/next/logo.png'),
    "loginLogo": require('../images/configure/next/logo.png'),
    "logoWidth": "156px",
    "loginLogoWidth": "314px",
    "banner":  require('../images/banner.png'),
    "bannerHref": '#',
    "areaCode": 'RegisterArea_HNDQ_Guangdong_SZ_FT',
    "areaName": '福田',
    "isallarea": false,
    "isLogin": true,
    "serviceType": "next"
  },
  {
    // 2025.11.05 按要求停用
    "name": "tgi",
    "appid": 'lgis',
    "serveid": '0c047c44-f126-4de1-aa16-110d8dba46cd',
    // "logo": require('../images/configure/lgis/logo.jpg'),    // 2024.2.4 根据需求去掉首页logo
    "loginLogo": require('../images/configure/lgis/logo.jpg'),
    "logoWidth": "115px",
    "loginLogoWidth": "237px",
    "banner": [require('../images/configure/lgis/banner_01.jpg'), require('../images/configure/lgis/banner_02.jpg'), require('../images/configure/lgis/banner_03.png')],
    "bannerHref": '#',
    "areaCode": 'RegisterArea_HNDQ_Guangdong_SZ_LG',
    "areaName": '龙岗',
    "isallarea": false,
    "isLogin": true,
    "serviceType": "lgis",
    "isLimitCity": true,
    "isSwiper": true, // 2024.10.12 根据需求加上首页轮播"
  },

   /*  已停用 E */



  {
    "name": "tgt",
    "appid": 'tazg',
    "serveid": 'd34d1ae0-7ee1-4d75-8cff-f8dd8ec83cba',
    "logo": require('../images/configure/tazg/logo.png'),
    "loginLogo": require('../images/configure/tazg/logo.png'),
    "logoWidth": "80px",
    "loginLogoWidth": "166px",
    "banner": require('../images/configure/tazg/banner.jpg'),
    "bannerHref": '#',
    "areaCode": 'RegisterArea_HNDQ_Guangdong_QingYuan',
    "areaName": '清远',
    "isallarea": true,
    "isLogin": true,
    "serviceType": "tiananzhigu"
  },
  {
    "name": "tgg",
    "appid": 'tqjg',
    "serveid": 'd1d4f89f-de87-4a66-b095-f631f0bb8b65',
    "logo": require('../images/configure/tqjg/logo.png'),   
    "loginLogo": require('../images/configure/tqjg/login.png'),
    "logoWidth": "115px",
    "loginLogoWidth": "237px",
    "banner": require('../images/configure/tqjg/banner.jpg'),
    "bannerHref": '#',
    "areaCode": 'RegisterArea_HNDQ_Guangdong_SZ',
    "areaName": '深圳',
    "isallarea": false,
    "isLogin": true,
    "serviceType": "ls"
  },
]

export default data



// WEBPACK FOOTER //
// ./src/assets/js/configure.js